import { Button } from 'components/Button';
import media from 'style-utils/media-queries';
import { Flex } from 'style/flexbox.style';
import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 28px;
  line-height: 28px;
  font-weight: 800;
  margin: 0;
  margin-bottom: 8px;
  font-family: var(--secondary-font-family), sans-serif;
`;

export const SubTitle = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin: 0;
  max-width: 406px;
  margin-bottom: 40px;
`;

export const ErrorPageWrapper = styled.div`
  height: 100vh;
  padding: 40px 24px;
  & > div {
    height: 100%;
  }
`;

export const ErrorPageContent = styled(Flex)`
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  ${media.desktop`
  flex-direction: row;
  justify-content: center;
  `};
`;

export const ErrorPageText = styled(Flex)`
  flex-direction: column;
`;

export const ErrorImage = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;

  ${media.desktop`
    max-width: 296px;
    margin-right: 40px;
  `};
`;

export const ContactButton = styled(Button)`
  width: 150px;
`;
